import React from 'react';
import $ from "jquery";
import {hashHistory} from "react-router";
import store from "../../../../../../store";

import {
  openModalFix,
  markCurrentStepForRemovalModalFix,
  setNextDisabledForCurrentStepModalFix,
  updateFeatureIdModalFix
} from "../../../../../../actions/sqftModalFunctions";
import {
  clearCacheForTheEdgeFeatures,
  setSQFTActiveButton,
  setSQFTMenuOpened
} from "../../../../../../actions/sqftMenuFunctions";
import {
  BACKSPLASH_LABELS,
  EDGE_LABELS,
  PART_IDS_THAT_CAN_BE_CHANGED_IN_SQFT,
  SIDEBAR_NAVIGATION_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SQFT_FEATURES,
} from "../../../../constants";
import {getCurrentLayout} from "../../../../../appLayout";
//import {getFeatureGroupName} from "../../../../../../misc/helpers";
//import workspace from "../../../canvas/core/workspace";
import {enableSquareFootage, setSQFTInVisualizer} from "../../../../../../actions/sqftFunctions";
import {
  getNextWizardSteps,
  getWizardGroupName
} from "../../../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import workspace from "../../../canvas/core/workspace";
import workspaceZoom from "../../../canvas/core/workspaceZoom";
import {getShapesCenter} from "../../../../helpers/conflictPopupHelper";
import sqftConfig from "../../../canvas/store/sqftConfig";
import {
  changeCartFeature,
  removeManyFromCart,
  setActiveFeature,
  updateCanvasCount,
  toggleSelectionFeatureInfo
} from "../../../../../../actions/actionFunctions";
import sqftShapeManager from "../../../canvas/store/sqftShapeManager";
import {updateFeatureInControllers} from "../../../canvas/store/workspaceControllers";
import {prepareSQFTDataCore} from "../../../canvas/core/workspace/workspaceDataMapper";
import {saveSQFTDataToQuote} from "../../../../helpers/sqftQuotesHelper";
import {fetchFeatures} from "../../../../hocs/useFetchFeatures";
import CommonCompatibilityUpdateWarning from "./CommonCompatibilityUpdateWarning";
import CommonCompatibilityRemoveWarning from "./CommonCompatibilityRemoveWarning";
import {
  setWizardActiveStep,
  setWizardConflictPopupOpened,
  setWizardConflictSteps,
  setWizardSelectedValues,
  updateAllWizardValues,
} from "../../../../../../actions/wizardFunctions";
import {changeAllCartItems} from "../../../../../../actions/shoppingCartFunctions";
import * as types from "../../../../../../actions/actionTypes";
import {getFeatureGroupName} from "../../../../../../misc/helpers";
import {getWizardPropertiesForFeature} from "../../../canvas/core/controls/resourseCanas";
import {disableFeature} from "../../../../../look/lookNavigation/lookFunctions2";
import {updateNavigationCount} from "../../../../../../actions/lookFunctions";
import {enableRegularMode, enableSlabMode} from "../../../canvas/store/canvasHelper";
import {showSlabTool} from "../../../../../../actions/sqftSlabFunctions";
import {setSQFTCartItemsToAdd} from "../../../../../../actions/sqftResourceFunctions";
import {
  categorizeConflictingCartItemsFromStore,
  getSqftCartItemSignature
} from "../../../../../popups/wizardConflictPopup/steps/conflictPopupHelper";
import {getNextNotCheckedStep} from "../../../../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {switchToWizardItem} from "../../../../../qkbPages/materialsWizard/useChangeWizardStepRoute";
import {getWizardOrFeatureGroupNavItems} from "../../../../helpers/sqftNavigationHelper";
import {checkWizardConflictingSteps} from "../../../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctionsConflictingLogic";
import ActionTypes from "../../../../../../misc/actionTypes";
import {isModalFixEnabled} from "../modalFixConfig";

const getNormalizedWizardConflictingSteps = (wizardConflictingSteps, sqftCartItems) => {
  return (wizardConflictingSteps || []).map((confStep) => {
    if ((!confStep.wizardGroupId || !Number.isInteger(confStep.stepIndex)) && confStep.cartFeature) {
      const alreadyAddedFeature = sqftCartItems.find((oldCartItem) => {
        return oldCartItem?.cartFeature?.dbFeature?.id === confStep.cartFeature?.dbFeature?.id;
      });

      if (alreadyAddedFeature && alreadyAddedFeature.fromWizardGroupId) {
        confStep.wizardGroupId = alreadyAddedFeature.fromWizardGroupId;
        confStep.stepIndex = alreadyAddedFeature.fromWizardStep;
      }
    }

    delete confStep.cartFeature;
    return confStep;
  });
};

const refreshWizardConflictSteps = () => {
  // Recompute the whole conflict list from current cart state after a fix.
  // This does not mutate existing conflict steps; it replaces them with a fresh result.
  const state = store.getState();
  const { activeQuoteIndex } = state.quotesState;
  const { cartItems } = state.cartState;
  const { sqftCartItems } = state.sqftResourceState;

  const cartItemsWithoutSQFTFeatures = cartItems.filter((cartItem) => !cartItem.sqftIds?.length && !cartItem.sqftId);
  const currentQuoteCartItems = [...sqftCartItems, ...cartItemsWithoutSQFTFeatures].filter((cartItem) => {
    return cartItem.currentQuote === activeQuoteIndex && cartItem.partId !== SQFT_FEATURES.slabs;
  });

  const { wizardConflictingSteps } = checkWizardConflictingSteps(currentQuoteCartItems);
  const normalizedWizardConflictingSteps = getNormalizedWizardConflictingSteps(wizardConflictingSteps, sqftCartItems);

  store.dispatch(setWizardConflictSteps(normalizedWizardConflictingSteps));
};

const removeSkippedStepsFromWizardSelectedValues = (completedSteps = []) => {
  const skippedStepIndexes = [
    ...new Set(
      completedSteps
        .filter((step) => step?.params?.shouldRemove && !step?.params?.isAssistingStep)
        .map((step) => step?.params?.stepIndex)
        .filter(Number.isInteger)
    )
  ];

  if (!skippedStepIndexes.length) {
    return;
  }

  const currentWizardSelectedValues = {
    ...(store.getState().wizardState.wizardSelectedValues || {})
  };

  skippedStepIndexes.forEach((stepIndex) => {
    delete currentWizardSelectedValues[stepIndex];
  });

  store.dispatch(setWizardSelectedValues(currentWizardSelectedValues, true));
};

const deleteSkippedCartItems = async (completedSteps = []) => {
  const completedState = store.getState();
  const completedCartItems = completedState.cartState.cartItems;
  const completedSqftCartItems = completedState.sqftResourceState.sqftCartItems || [];
  const completedAllCartItems = [...completedCartItems, ...completedSqftCartItems];
  const targetCartItemsMarkedForRemoval = completedSteps
    .filter((step) => step?.params?.shouldRemove && !step?.params?.isAssistingStep)
    .flatMap((step) => {
      return getTargetCartItems(
        completedAllCartItems,
        step?.params?.cartItemIds || [],
        step?.params?.cartItemSignatures || []
      );
    });
  const cartItemIdsMarkedForRemoval = [
    ...new Set(targetCartItemsMarkedForRemoval.map((item) => item.id))
  ];

  await deleteIncompatibleCartItems(cartItemIdsMarkedForRemoval);
  await disableSkippedCartItemsOnVisualizer(targetCartItemsMarkedForRemoval);
};

const disableSkippedCartItemsOnVisualizer = async (targetCartItemsMarkedForRemoval = []) => {
  const featuresToDisable = [
    ...new Map(
      targetCartItemsMarkedForRemoval
        .map((item) => item?.cartFeature)
        .filter((feature) => feature?.getParent && feature?.partId)
        .map((feature) => [`${feature.partId}:${feature.dbFeature?.id || feature.getFeatureName?.() || ''}`, feature])
    ).values()
  ];

  for (const feature of featuresToDisable) {
    await disableFeature(feature);
  }

  if (featuresToDisable.length) {
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
    store.dispatch(updateCanvasCount());
  }
};

// Resolve modal-fix step items by current ids first, then by saved SQFT signature
// if temp SQFT cart items were rebuilt and received new UUIDs.
const getTargetCartItems = (allCartItems, cartItemIds = [], cartItemSignatures = []) => {
  const cartItemIdsSet = new Set(cartItemIds);
  const cartItemSignaturesSet = new Set((cartItemSignatures || []).filter(Boolean));

  return allCartItems.filter((item) => {
    if (cartItemIdsSet.has(item.id)) {
      return true;
    }

    if (!cartItemSignaturesSet.size) {
      return false;
    }

    const cartItemSignature = getSqftCartItemSignature(item);
    return !!cartItemSignature && cartItemSignaturesSet.has(cartItemSignature);
  });
};

export const handleOpenModalFix = async (props) => {
  const {changeWizardStepRoute, intl} = props;

  if (!isModalFixEnabled()) {
    return;
  }

  const state = store.getState();
  const { wizardActiveItem, wizardActiveStep, wizardSelectedValues } = state.wizardState;
  const { selectionFeatureInfo } = state.selectionState;
  const {isModalFixOpen} = state.sqftModalFixState;
  const {isSquareFootageEnabled} = state.sqftState;
  const fabricatorData = state.fabricatorState;

  const layout = getCurrentLayout();

  // Categorize conflicting items using wrapper
  const { itemsToRemove, itemsToUpdate, itemsToUpdateGrouped } = categorizeConflictingCartItemsFromStore();

  console.log('Items to remove:', itemsToRemove);
  console.log('Items to update:', itemsToUpdate);
  console.log('Items to itemsToUpdateGrouped:', itemsToUpdateGrouped);

  if ((itemsToRemove.length > 0 || itemsToUpdate.length > 0) && !isModalFixOpen) {
    // Remove incompatible items
    const cartItemIdsToRemove = itemsToRemove.map(item => item.cartItem.id);
    await deleteIncompatibleCartItems(cartItemIdsToRemove);

    // Create steps for items that need updating
    const steps = [];

    const wizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

    for (const group  of itemsToUpdateGrouped) {
      const itemData = group.representative;
      const { cartItem, wizardConflictingStep } = itemData;
      const cartItemIds = group.cartItemIds;
      const cartItemSignatures = group.cartItemSignatures;

      const partId = cartItem.partId;
      const featureGroup = layout.getFeatureGroupByPartId(partId);

      const wizardGroup = wizardActiveItem.wizardGroups.find(wizGroup => {
        return wizGroup.id === wizardConflictingStep.wizardGroupId
      });

      if (!wizardGroup) {
        console.error('wizardGroup was not found for the wizardConflictingStep');
        continue;
      }

      const wizardGroupName = getWizardGroupName(wizardGroup);
      const featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
      const groupName = wizardGroupName || featureGroupName;
      const buttonName = getButtonNameForPartId(partId);
      const featuresData = await fetchFeatures([partId], '', {}, true);

      let sameNewWizardStep = wizardSteps.find(step => step.stepIndex === wizardConflictingStep.stepIndex);
      if (!sameNewWizardStep || sameNewWizardStep.stepGroups?.[0]?.groupName !== wizardGroup.groupName) {
        sameNewWizardStep = wizardSteps.find(step => step.stepGroups?.[0]?.groupName === wizardGroup.groupName)
      }
      const isSQFTStep = cartItem.sqftId && PART_IDS_THAT_CAN_BE_CHANGED_IN_SQFT.includes(partId);
      const isSQFTInVisualizerStep = cartItem.sqftId || Array.isArray(cartItem.sqftIds);

      const title = intl.formatMessage({id: "modalFix.title.update"}, {groupName});

      // Tiny helper: avoid repeating the same zoom timeout block
      const zoomToShapesCenter = () => {
        setTimeout(() => {
          const shapes = workspace.getShapesWithoutAttachedResources();
          const centerPoint = getShapesCenter(shapes);
          workspaceZoom.zoomTo(centerPoint, 0.1);
        }, 700);
      };

      // Factory: returns the onStepEnter handler for a given targetStepIndex
      const makeOnStepEnter = (targetStepIndex) => (stepData) => {
        if (isSQFTStep) {
          store.dispatch(enableSquareFootage(true));
          store.dispatch(setSQFTInVisualizer(false));

          if (stepData.isSQFTStep && getWizardOrFeatureGroupNavItems(partId, featuresData[partId]).length > 0) {
            store.dispatch(setSQFTMenuOpened(buttonName));
            store.dispatch(setSQFTActiveButton(buttonName));
            enableRegularMode();
            store.dispatch(showSlabTool(false));
          }

          zoomToShapesCenter();
          return;
        }

        // Non-SQFT step enter
        store.dispatch(enableSquareFootage(isSQFTInVisualizerStep));
        if (selectionFeatureInfo) {
          store.dispatch(toggleSelectionFeatureInfo(null));
        }

        store.dispatch(updateNavigationCount());
        store.dispatch(setSQFTInVisualizer(true));

        if (changeWizardStepRoute) {
          changeWizardStepRoute(targetStepIndex, wizardActiveItem, wizardSteps);
        }

        sqftConfig.setScale(2.5);
        zoomToShapesCenter();
      };

      const onStepExit = () => {
        store.dispatch(setSQFTMenuOpened(''));
        store.dispatch(setSQFTActiveButton(''));
      };

      const newStep = {
        id: 'incompatibleCartItems',
        title,
        content: getContentForFeatureGroup(featureGroup, groupName, false, true),
        partId: cartItem.partId,
        featureId: cartItem.cartFeature.dbFeature.id,
        featureName: cartItem.cartFeature.getFeatureName(),
        isSQFTStep,
        params: {
          shouldRemove: false,
          cartItemIds: cartItemIds,
          cartItemSignatures,
          stepIndex: sameNewWizardStep.stepIndex,
        },
        showClose: false,
        showCancel: true,
        showSkip: true,
        skipButtonText: 'Skip',
        isNextButtonDisabled: true,
        enterAnim: 'fadeDown',
        exitAnim: 'fadeUp',
        onStepEnter: makeOnStepEnter(sameNewWizardStep.stepIndex),
        onStepExit,
      };

      // 1) add prev step if it is the same group and requires to select style (renuit issue)
      const prevTargetStepIndex = sameNewWizardStep.stepIndex - 1;
      const prevWizardStep = wizardSteps.find(step => step.stepIndex === prevTargetStepIndex);
      const prevGroup = prevWizardStep?.stepGroups?.[0];

      const shouldAddPrevStyleStep =
        !!sameNewWizardStep
        && !!prevWizardStep
        && !!prevGroup?.hidePriceNoCart
        && prevGroup?.groupName === wizardGroup.groupName;

      if (
        shouldAddPrevStyleStep
        && !steps.some((step) => step?.params?.stepIndex === prevTargetStepIndex)
      ) {
        steps.push({
          ...newStep,
          showSkip: false,
          params: {
            ...newStep.params,
            isAssistingStep: true,
            cartItemIds: [],
            cartItemSignatures: [],
            stepIndex: prevTargetStepIndex,
          },
          onStepEnter: makeOnStepEnter(prevTargetStepIndex),
        });
      }

      // 2) push original step
      steps.push(newStep);
    }

    const jumpToStepAfterFinish = getNextNotCheckedStep(true);
    const isSQFTEnabledSnapshot = !!state.sqftState?.isSquareFootageEnabled;

    // 3) add prev/next for each step
    steps.forEach((step, idx) => {
      const isFirst = idx === 0;
      const isLast = idx === steps.length - 1;

      step.showPrev = !isFirst;
      step.nextButtonText = isLast ? 'Finish' : 'Next';
      if (isLast) {
        const prevOnStepExit = step.onStepExit;
        step.onStepExit = (...args) => {
          if (typeof prevOnStepExit === 'function') { // keep existing behavior
            prevOnStepExit(...args);
          }
          let currentWizardSelectedValues = store.getState().wizardState.wizardSelectedValues;
          Object.keys(currentWizardSelectedValues).forEach(key => {
            if (currentWizardSelectedValues[key].isAutoSkippedStep) {
              delete currentWizardSelectedValues[key]
            }
          });
          store.dispatch(setWizardSelectedValues(currentWizardSelectedValues, true)); // update allWizardSelectedValues in the end
          if (itemsToUpdate.length && !isSQFTEnabledSnapshot) {
            changeWizardStepRoute(jumpToStepAfterFinish, wizardActiveItem);
          }
        };
      }
    });

    console.log('steps', steps);
    console.log('cartItemIdsToRemove', cartItemIdsToRemove);

    if (!isModalFixOpen && steps.length > 0) {
      store.dispatch(openModalFix('incompatibleCartItems', steps, async (completedSteps = []) => {
        console.log('Modal completed');
        removeSkippedStepsFromWizardSelectedValues(completedSteps);
        await deleteSkippedCartItems(completedSteps);

        store.dispatch(setSQFTInVisualizer(false));
        store.dispatch(setWizardConflictSteps([]));
        store.dispatch(setSQFTCartItemsToAdd([]));

        sqftConfig.initializeDependentProperties();
        if (isSquareFootageEnabled) {
          setTimeout(() => {
            let centerPoint = getShapesCenter(workspace.getShapesWithoutAttachedResources());
            workspaceZoom.zoomTo(centerPoint, 0.1);
          }, 700);
        }
      }));
    }

    store.dispatch(setWizardSelectedValues({
      [wizardActiveStep]: wizardSelectedValues[wizardActiveStep]
    })); // passed already selected value to update conflicting steps
  }
};

const getContentForFeatureGroup = (featureGroup, featureGroupName, shouldRemove, showSkipWarning = false) => {
  if (shouldRemove) {
    return React.createElement(CommonCompatibilityRemoveWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName
    });
  } else {
    return React.createElement(CommonCompatibilityUpdateWarning, {
      featureGroup: featureGroup,
      featureGroupName: featureGroupName,
      showSkipWarning
    });
  }
}

const getButtonNameForPartId = (partId) => {
  if (Object.keys(EDGE_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.edge
  } else if (Object.keys(BACKSPLASH_LABELS).includes(partId)) {
    return SIDEBAR_NAVIGATION_BUTTONS.backsplash
  } else if (SQFT_FEATURES.crown_molding === partId) {
    return SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding
  } else if (SQFT_FEATURES.radius === partId) {
    return SIDEBAR_NAVIGATION_BUTTONS.radius
  }
}

export const deleteIncompatibleCartItems = async (cartItemIds) => {
  const cartItemIdsToRemove = [];
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  const sqftCartItems = state.sqftResourceState.sqftCartItems;
  const cartItemsAndSQFTTempCartItems = [...cartItems, ...sqftCartItems];
  const sqftIdsToRemove = [];
  for (const cartItemId of cartItemIds) {
    cartItemIdsToRemove.push(cartItemId);
    const cartItem = cartItemsAndSQFTTempCartItems.find(cartItem => cartItem.id === cartItemId);

    //remove sqft items
    if (cartItem && cartItem.sqftId) {
      workspace.removeFeatureBySQFTId(cartItem.sqftId);
      sqftIdsToRemove.push(cartItem.sqftId);
    }

    if (cartItem && cartItem.sqftIds && cartItem.sqftIds.length) {
      for (const sqftId of cartItem.sqftIds) {
        workspace.removeFeatureBySQFTId(sqftId);
        sqftIdsToRemove.push(sqftId);
      }
    }
  }
  if (sqftIdsToRemove.length > 0) {
    const coreData = prepareSQFTDataCore();
    await saveSQFTDataToQuote(coreData);
  }
  if (cartItemIdsToRemove.length > 0) {
    store.dispatch(removeManyFromCart(cartItemIdsToRemove));
  }
}

/**
 * Apply the selected replacement feature for the current modal-fix step.
 * 1. Resolve target cart items by step ids and, if needed, by saved SQFT signature.
 * 2. Replace the feature in both cart state and SQFT temp cart items.
 * 3. Update workspace shapes/controllers still linked to the old incompatible feature.
 * 4. Refresh wizard conflict steps because the replacement can change remaining conflicts.
 * 5. Save the updated SQFT data and unlock modal navigation.
 */
export const fixFeature = async (currentFeature, passedWizardProps) => {
  const state = store.getState();
  const { sqftModalFixState, cartState, sqftResourceState } = state;

  if (!sqftModalFixState.isModalFixOpen) {
    return;
  }

  const cartItems = cartState.cartItems;
  const sqftCartItems = sqftResourceState.sqftCartItems || [];
  const allCartItems = [...cartItems, ...sqftCartItems];
  const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
  const cartItemIds = currentStepData?.params?.cartItemIds || [];
  const cartItemSignatures = currentStepData?.params?.cartItemSignatures || [];
  const isAssistingStep = currentStepData?.params?.isAssistingStep;

  if (isAssistingStep) {
    store.dispatch(markCurrentStepForRemovalModalFix(false));
    store.dispatch(setNextDisabledForCurrentStepModalFix(false));
    return;
  }

  if (!cartItemIds.length && !cartItemSignatures.length) {
    console.error('fixFeature: cartItemIds and cartItemSignatures are empty');
    return;
  }

  // Resolve step targets by current ids first, then fall back to the saved SQFT signature
  // when sqft cartItems were rebuilt and received new UUIDs.
  const targetCartItems = getTargetCartItems(allCartItems, cartItemIds, cartItemSignatures);
  const targetCartItemIdsSet = new Set(targetCartItems.map((item) => item.id));
  const firstCartItem = targetCartItems.find((item) => !item.bundleParentId) || targetCartItems[0];

  if (!firstCartItem) {
    console.error("fixFeature: firstCartItem was not found", {
      cartItemIds,
      cartItemSignatures,
      currentStepData,
      cartItemIdsInCart: cartItems.map((item) => item.id),
      cartItemIdsInSqft: sqftCartItems.map((item) => item.id),
      cartItemSignaturesInCart: allCartItems.map((item) => getSqftCartItemSignature(item)),
    });
    store.dispatch(setNextDisabledForCurrentStepModalFix(false));
    return;
  }

  const incompatibleFeatureId = firstCartItem.cartFeature?.dbFeature?.id;
  const wizardProps = passedWizardProps || getWizardPropertiesForFeature(currentFeature);
  const {fromWizardId, fromWizardStep, fromWizardGroupId} = wizardProps;

  // Keep SQFT temp cart items in sync with the feature selected in modal fix.
  const updatedSqftCartItems = sqftCartItems.map((cartItem) => {
    if (!targetCartItemIdsSet.has(cartItem.id) || cartItem.bundleParentId) {
      return cartItem;
    }

    return {
      ...cartItem,
      cartFeature: currentFeature,
      fromWizardId,
      fromWizardStep,
      fromWizardGroupId
    };
  });

  // Update cart items
  for (const cartItem of cartItems) {

    if (!targetCartItemIdsSet.has(cartItem.id) || cartItem.bundleParentId) {
      continue;
    }

    const newItem = {
      ...cartItem,
      cartFeature: currentFeature,
      fromWizardId,
      fromWizardStep,
      fromWizardGroupId
    };

    store.dispatch(changeCartFeature(newItem));
  }

  store.dispatch(setSQFTCartItemsToAdd(updatedSqftCartItems));

  // Replace visualizer resources that still point to the old incompatible feature.
  if (!incompatibleFeatureId) {
    console.error("fixFeature: incompatibleFeatureId was not found", {
      firstCartItem,
      currentStepData,
    });
  } else {
    const incompatibleShapes = workspace.getShapesByFeatureId(incompatibleFeatureId);
    for (const shape of incompatibleShapes) {
      sqftShapeManager.setShapeFeature(shape.id, currentFeature);
    }

    // Update controller resources (handles, hinges, etc.) for the replaced feature
    updateFeatureInControllers(incompatibleFeatureId, currentFeature);

    // Update parent feature shapes
    const incompatibleParentShapes = workspace.getShapesByParentFeatureId(incompatibleFeatureId);
    for (const shape of incompatibleParentShapes) {
      sqftShapeManager.setShapeRelatedParentFeatureId(shape.id, currentFeature.dbFeature.id, currentFeature.partId);
    }
  }

  sqftShapeManager.updateShapesWizardProperties();

  // Recompute conflicts after the replacement because this step may have resolved
  // itself and/or changed the remaining conflict list.
  refreshWizardConflictSteps();

  // Save quote
  const coreData = prepareSQFTDataCore();
  await saveSQFTDataToQuote(coreData);

  // Update modal state
  store.dispatch(updateFeatureIdModalFix(currentFeature.dbFeature.id, currentFeature.getFeatureName()));
  store.dispatch(markCurrentStepForRemovalModalFix(false));
  store.dispatch(setNextDisabledForCurrentStepModalFix(false));
  store.dispatch(clearCacheForTheEdgeFeatures());
};

/**
 * Create a snapshot of current state before making changes
 * (cartItems, sqftCalcData, wizardSelectedValues)
 */
export const createModalFixSnapshot = () => {
  const state = store.getState();
  const cartItems = state.cartState.cartItems;
  const isSquareFootageEnabled = !!state.sqftState?.isSquareFootageEnabled;
  const {
    wizardActiveItem,
    wizardSelectedValues,
    allWizardsValues,
    beforeConflictSelectedValues,
    wizardActiveStep,
  } = state.wizardState;
  const { activeFeature, selectionFeatureInfo } = state.selectionState;

  // Get SQFT data only when calculator is active.
  const sqftCalcData = isSquareFootageEnabled ? prepareSQFTDataCore() : null;

  return {
    cartItems: cartItems.map(cartItem => ({...cartItem})),
    wizardSelectedValues: Object.keys(wizardSelectedValues).reduce((acc, key) => {
      acc[key] = {...wizardSelectedValues[key]};
      return acc;
    }, {}),
    allWizardsValues: allWizardsValues.map(wizardValue => ({
      ...wizardValue,
      wizardSelectedValues: {...wizardValue.wizardSelectedValues},
    })),
    beforeConflictSelectedValues: Object.keys(beforeConflictSelectedValues || {}).reduce((acc, key) => {
      acc[key] = {...beforeConflictSelectedValues[key]};
      return acc;
    }, {}),
    wizardActiveItemId: wizardActiveItem?.id ?? null,
    wizardActiveStep,
    activeFeature,
    selectionFeatureInfo,
    locationHash: window.location.hash ? window.location.hash.replace(/^#/, "") : "",
    wasSquareFootageEnabled: isSquareFootageEnabled,
    sqftCalcData: sqftCalcData,
    timestamp: Date.now()
  };
};

/**
 * Restore state from snapshot
 */
export const restoreFromSnapshot = async (snapshot) => {
  if (!snapshot) {
    console.warn('No snapshot to restore');
    return;
  }

  console.log('Restoring from snapshot', snapshot);
  const state = store.getState()
  const isShowSlabTool = state.sqftSlabState.isShowSlabTool;
  const { wizardActiveItem, wizardList } = state.wizardState;
  const { activeQuoteIndex } = state.quotesState;

  // 1. Restore cart items
  const cartItems = [...snapshot.cartItems];
  store.dispatch(changeAllCartItems(cartItems));

  // 2. Restore workspace state
  if (snapshot.wasSquareFootageEnabled && snapshot.sqftCalcData) {
    workspace.import(snapshot.sqftCalcData);
  }

  // 3. Restore wizard flow through regular action creators so footer/context state is recalculated
  store.dispatch(updateAllWizardValues(snapshot.allWizardsValues || []));
  store.dispatch(setWizardConflictPopupOpened(false));

  const restoredWizardItem = snapshot.wizardActiveItemId
    ? wizardList.find(item => item.id === snapshot.wizardActiveItemId)
    : wizardActiveItem;

  if (restoredWizardItem && Number.isInteger(snapshot.wizardActiveStep)) {
    switchToWizardItem(
      restoredWizardItem,
      snapshot.wizardActiveStep,
      activeQuoteIndex,
      snapshot.wizardSelectedValues?.[snapshot.wizardActiveStep]?.wizardGroup?.id || null,
      true,
      false
    );
  } else {
    store.dispatch(setWizardSelectedValues(
      snapshot.wizardSelectedValues || {},
      true,
      wizardActiveItem,
      activeQuoteIndex
    ));
    store.dispatch(setWizardActiveStep(
      Number.isInteger(snapshot.wizardActiveStep) ? snapshot.wizardActiveStep : state.wizardState.wizardActiveStep,
      wizardActiveItem,
      activeQuoteIndex
    ));
  }

  store.dispatch(setActiveFeature(snapshot.activeFeature || null));
  store.dispatch(toggleSelectionFeatureInfo(snapshot.selectionFeatureInfo || null));

  store.dispatch({
    type: types.SET_WIZARD_SELECTED_VALUES,
    payload: {
      wizardSelectedValues: snapshot.wizardSelectedValues || {},
      wizardConflictingSteps: [],
      beforeConflictSelectedValues: snapshot.beforeConflictSelectedValues || {},
    }
  });

  // 4.) Switch slab mode if it was opend
  if (isShowSlabTool) {
    enableSlabMode();
    store.dispatch(showSlabTool(true));
  }

  if (snapshot.locationHash) {
    const currentHash = window.location.hash ? window.location.hash.replace(/^#/, "") : "";
    if (currentHash !== snapshot.locationHash) {
      hashHistory.push(snapshot.locationHash);
    }
  }

  console.log('Snapshot restored successfully');
};
